<template>
  <div class="activityDialog">
    <el-dialog
      top="3%"
      width="50%"
      :title="dialogTitle"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :before-close="closeEvent"
    >
      <el-form ref="dialogForm" :model="form" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="跳转页面路径">
              <el-input v-model="form.pages"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序">
              <el-input v-model="form.lunSort"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="轮播图" prop="name">
              <el-upload
                class="avatar-uploader"
                :headers="headers"
                :show-file-list="false"
                action="/api/upload?group=banner"
                :on-success="handleAvatarSuccess"
              >
                <img v-if="form.imgUrl" :src="form.imgUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详情图" prop="name">
              <el-upload
                class="avatar-uploader"
                :headers="headers"
                :show-file-list="false"
                action="/api/upload?group=bannerDetails"
                :on-success="handleAvatarSuccess2"
              >
                <img v-if="form.detailsUrl" :src="form.detailsUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeEvent()">取 消</el-button>
        <el-button type="primary" @click="submitData()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      dialogTitle: "新增轮播",
      headers: {
        token: localStorage.getItem("token"),
      },
      memberId: "",
      form: {
        imgUrl: "",
        pages: "",
        detailsUrl:"",
        lunSort:"",
      },
    };
  },
  methods: {
    handleAvatarSuccess(res) {
      this.form.imgUrl = res.data.path;
    },
    handleAvatarSuccess2(res) {
      this.form.detailsUrl = res.data.path;
    },
    async submitData() {
      let params = { ...this.form };
      params.createTime = new Date().getTime();
      let url = "";
      if (params.id) {
        //修改
        url = "api/carousel/update";
      } else {
        url = "api/carousel/add";
      }

      this.getAjax(url, params, "post").then(() => {
        this.$message.success("操作成功");
        this.closeEvent();
        this.$emit("search");
      });
    },
    closeEvent() {
      this.visible = false;
      this.dialogTitle = "新增轮播";
      this.form = {};
    },
    getInfo(item) {
      this.visible = true;
      this.dialogTitle = "编辑轮播";
      this.form = JSON.parse(JSON.stringify(item));
    },
  },
  mounted() {},
};
</script>

<style lang="less">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
